import styled from '@emotion/styled';
import React from 'react';
import { mqMin } from 'utils/responsive';

const DescriptionText = styled.p`
    font-family: 'Zen Kaku Gothic Antique', -apple-system, Roboto, Helvetica, sans-serif;
    font-size: 0.96rem;
    line-height: 160%;
    letter-spacing: 0.8px;
    color: #1e4e66;
    margin: 0;
`;

const HighlightText = styled.span`
    font-weight: 600;
    color: #ee793f;
    background-color: #fffbc9;
`;

const ContentWrapper = styled.div`
    position: relative;
    width: 100%;
    margin-top: 40px;
    display: flex;
    justify-content: center;
`;

const GridContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    gap: 16px;
    justify-content: center;

    ${mqMin('SP')} {
        display: grid;
        grid-template-columns: 270px 270px;
        grid-template-rows: 83px 83px;
    }
`;

const ServiceBox = styled.div`
    width: 100%;
    height: 83px;
    border-radius: 12px;
    border: 2px solid #1e4e66;
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 20px;

    ${mqMin('SP')} {
        width: 270px;
        height: 83px;
    }
`;

const ServiceText = styled.div`
    color: #1e4e66;
    text-align: center;
    font-family: 'Zen Kaku Gothic Antique', -apple-system, Roboto, Helvetica, sans-serif;
    font-size: 16px;
    font-weight: 700;
    line-height: 160%;
    letter-spacing: 0.8px;
    white-space: pre-line;
`;

export const MaForBeginnerDerail_2_2: React.FC = () => {
    return (
        <>
            <DescriptionText>
                仲介会社の主な業務は、
                <HighlightText>
                    ①企業価値の査定・企業紹介資料の作成、②候補先の探索とマッチング、③条件交渉の調整、④契約書作成や法務・税務の専門家との連携
                </HighlightText>
                です。さらに、売却理由やオーナーの希望を踏まえた上で、従業員の雇用継続や取引先との関係維持にも配慮した提案を行います。初めてM&Aを進める場合、複雑な法務手続きや交渉の不安を軽減し、安心して進められるのが仲介会社の大きな役割です。
            </DescriptionText>
            <ContentWrapper>
                <GridContainer>
                    <ServiceBox>
                        <ServiceText>{'①企業価値の査定・\n企業紹介資料の作成'}</ServiceText>
                    </ServiceBox>
                    <ServiceBox>
                        <ServiceText>{'②候補先の探索と\nマッチング'}</ServiceText>
                    </ServiceBox>
                    <ServiceBox>
                        <ServiceText>③条件交渉の調整</ServiceText>
                    </ServiceBox>
                    <ServiceBox>
                        <ServiceText>{'④契約書作成や\n法務・税務の専門家との連携'}</ServiceText>
                    </ServiceBox>
                </GridContainer>
            </ContentWrapper>
        </>
    );
};
